/* eslint-disable */
import * as Types from '../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import { AddressDetails__AddressFragmentDoc } from '../addresses/Addresses.generated.js';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ProjectLocationQueryVariables = Types.Exact<{
  projectId: Types.Scalars['ID']['input'];
}>;


export type ProjectLocationQuery = { project: { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } | { __typename: 'ProjectResult', project?: { __typename: 'Project', id: string, buildingInfo?: { __typename: 'BuildingInfo', id: string, title: string, buildingAddress?: { __typename: 'Address', id: string, streetLines1: string, city: string, postalCode: string, countryCode: string, location?: { __typename: 'Location', lat: number, lng: number } | null } | null } | null } | null } };


export const ProjectLocationDocument = gql`
    query ProjectLocation($projectId: ID!) {
  project(id: $projectId) {
    ... on ProjectResult {
      project {
        id
        buildingInfo {
          id
          title
          buildingAddress {
            ...AddressDetails__Address
          }
        }
      }
    }
  }
}
    ${AddressDetails__AddressFragmentDoc}`;

/**
 * __useProjectLocationQuery__
 *
 * To run a query within a React component, call `useProjectLocationQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectLocationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectLocationQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useProjectLocationQuery(baseOptions: Apollo.QueryHookOptions<ProjectLocationQuery, ProjectLocationQueryVariables> & ({ variables: ProjectLocationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectLocationQuery, ProjectLocationQueryVariables>(ProjectLocationDocument, options);
      }
export function useProjectLocationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectLocationQuery, ProjectLocationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectLocationQuery, ProjectLocationQueryVariables>(ProjectLocationDocument, options);
        }
export function useProjectLocationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProjectLocationQuery, ProjectLocationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProjectLocationQuery, ProjectLocationQueryVariables>(ProjectLocationDocument, options);
        }
export type ProjectLocationQueryHookResult = ReturnType<typeof useProjectLocationQuery>;
export type ProjectLocationLazyQueryHookResult = ReturnType<typeof useProjectLocationLazyQuery>;
export type ProjectLocationSuspenseQueryHookResult = ReturnType<typeof useProjectLocationSuspenseQuery>;
export type ProjectLocationQueryResult = Apollo.QueryResult<ProjectLocationQuery, ProjectLocationQueryVariables>;